/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

var _registerToActions = function(action){

    switch(action.actionType)
    {
        case Constants.ON_AUTHENTICATE:
            this.authentication =  action.response;
            this.emit(Constants.ON_AUTHENTICATE);
            break;
    }
};

class AuthenticationStore extends BaseStore{

    constructor(){
        super();
        this.subscribe(() => _registerToActions.bind(this));
    }

    isAuthenticated(){
        return sessionStorage.getItem('USER_TOKEN') ? true : false
    }

}

export default new AuthenticationStore();